<template>
    <div @click="showRequestForm" class="request_form_card">
        <div class="header_section">
            <div  class="profile_section">
                <ProfileImage :image-path="userInfo.image_path" style="width: 40px;"></ProfileImage>
                <div class="profile_info">
                    <div class="name_row">
                        <div class="player_name">
                            {{ (userInfo.additional_info_name || userInfo.name || '').charAt(0) + '**' }}
                            <span v-if="userInfo.is_parent_verified == 1">
                                <img style="width: 13px;" :src="require('@/assets/img/verified_parent.png')" alt="">
                            </span>
                        </div>
                    </div>
                    <!-- <div class="location">{{ userInfo.place_name }}</div> -->
                </div>
                <div class="secret_request_btn">
                    시크릿 입단 요청서
                </div>
            </div>
        </div>

        <div style="">
            <div class="stats_section">
                <div class="stat_item">
                    <div class="stat_label">포지션</div>
                    <div class="stat_value">{{ userInfo.additional_info_position || userInfo.position || '-' }}</div>
                </div>
                <div class="stat_divider"></div>
                <div class="stat_item">
                    <div class="stat_label">신장</div>
                    <div class="stat_value">{{ heightText }}</div>
                </div>
                <div class="stat_divider"></div>
                <div class="stat_item">
                    <div class="stat_label">체중</div>
                    <div class="stat_value">{{ weightText }}</div>
                </div>
                <div class="stat_divider"></div>
                <div class="stat_item">
                    <div class="stat_label">주발</div>
                    <div class="stat_value">{{ footWayText }}</div>
                </div>
            </div>

            <div class="region_section">
                <div class="region_label">희망 지역:</div>
                <div class="region_list">
                    <template v-if="userInfo.additional_info_region && userInfo.additional_info_region.length > 0">
                        <div class="region_item" v-for="each, i in userInfo.additional_info_region.split(',')" :key="i + 'region_list'">
                            {{ each }}
                        </div>
                    </template>
                    <template v-else>
                        <div class="region_item">전국</div>
                    </template>
                </div>
            </div>
        
            <div style="padding-bottom: 6px;" class="intro_section">
                <div class="quote">{{ userInfo.additional_info_introduce }}</div>
                <div class="intro_text_wrapper">
                    <div class="intro_text">{{ $Util.removeYoutubeLink(userInfo.contents) }}</div>
                </div>
            </div>

            <div class="hide_scroll" style="display: flex; gap: 6px; margin-top: 10px; overflow-x: auto; padding-bottom: 10px; filter: blur(3px);">
                <div v-for="each, i in imgPathArr" :key="i" style="width: 100px; flex-shrink: 0; height: 100px; border-radius: 6px; overflow: hidden;">
                    <img style="width: 100%; height: 100%; object-fit: cover;" :src="$resourcePath + each" alt="">
                </div>
            </div>

            <div style="width: 100%; height: 1px; background: #210F031A;"></div>
            
            <div style="padding-top: 10px; display: flex; justify-content: space-between;">
                <div style="display: flex; align-items: center; gap: 10px; margin-left: 17px;">
                    <div @click.stop="toggleTouch" style="display: flex; gap: 5px; align-items: center;">
                        <div style="position: relative;">
                            <img :style="{ opacity: curLikeYn === IS_LIKE.LIKE ? '1' : '0' }" ref="shoot" style="width: 40px; z-index: 1; opacity: 0; left: -23px; position: absolute; top: -1px;" :src="require('@/assets/img/shoot_orange.png')" alt="">
                            <img style="width: 16px; position: relative; z-index: 2;" ref="soccerBall" :src="require('@/assets/img/soccer_ball_reply_active.png')" alt="">
                        </div>
                        <div style="font-weight: 700; font-size: 12px; color: #210F03;">{{ curLikeNumber }}</div>
                    </div>
                    <div style="display: flex; align-items: center; gap: 5px;">
                        <img style="width: 16px;" :src="require('@/assets/img/request_icon.png')" alt="">
                        <div style="font-size: 12px; line-height: 24px; font-weight: 600; color: #210F03;">{{ parseInt(userInfo.received_request_count) + parseInt(userInfo.interest_count) }}</div>
                    </div>
                </div>
                <div style="font-weight: 600; font-size: 12px; line-height: 24px; color: #808080;">{{ userInfo.last_top_date ? formatInsertDate(userInfo.last_top_date) : formatInsertDate(userInfo.insert_date) }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import ProfileImage from '@/components/common/ProfileImage'
import { PROFILE_FOOT_WAY, MEMBER_TYPE, JOIN_CHAT_TYPE } from '@/Constants'
import moment from 'moment'
import ResponseCode from '@/ResponseCode'

const IS_LIKE = {
    LIKE: 1,
    UNLIKE: 0
}

export default {
    name: 'CommonSecretRequestForm',
    components: { ProfileImage },
    props: {
        userInfo: {
            type: Object,
            default: () => {}
        },
        completeAction: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            PROFILE_FOOT_WAY: PROFILE_FOOT_WAY,
            IS_LIKE: IS_LIKE,
            copyUserInfo: {}
        }
    },
    watch: {
        userInfo: {
            handler() {
                this.setCopyUserInfo()
            },
            deep: true
        }
    },
    computed: {
        curLikeYn() {
            return parseInt(this.copyUserInfo.like_yn)
        },
        curLikeNumber() {
            return parseInt(this.copyUserInfo.like_number)
        },
        heightText() {
            const height = this.userInfo.height || this.userInfo.additional_info_height;
            return height ? `${height}cm` : '-';
        },
        weightText() {
            const weight = this.userInfo.additional_info_weight;
            return weight ? `${weight}kg` : '-';
        },
        footWayText() {
            const footWay =
                this.userInfo.foot_way ??
                this.userInfo.additional_info_foot_way;

            return footWay ? this.transFootWay(footWay) : '-';
        },
        imgPathArr() {
            const imgPathArr = []
            for (let i = 1; i < 4; i++) {
                const key = `thumbnail_path${i}`;
                if (this.userInfo[key]) {
                    imgPathArr.push(this.userInfo[key])
                }
            }
            return imgPathArr
        }
    },
    methods: {
        transFootWay(footWay) {
            if (footWay == 0) {
                return '양발'
            } else if (footWay == 1) {
                return '왼발'
            } else if (footWay == 2) {
                return '오른발'
            } else {
                return ''
            }
        },
        setFootWay(footWay) {
            if (footWay == PROFILE_FOOT_WAY.LEFT) {
                return '왼발'
            } else if (footWay == PROFILE_FOOT_WAY.RIGHT) {
                return '양발'
            } else {
                return '오른발'
            }
        },
        showRequestForm() {
            const is_send_request = this.copyUserInfo.is_send_secret_request
            const is_confirm = this.copyUserInfo.is_secret_request_accepted
            const is_skip = this.copyUserInfo.is_skip
            if (this.$GlobalStore.loginInfo().idx === this.userInfo.writer_idx) {
                this.$GlobalStore.addModal('RequestReportDetailSecret', { soccerhowIdx: this.userInfo.idx, is_parent_verified: this.userInfo.is_parent_verified, completeAction: this.completeAction })
                return
            }
            
            if (this.$GlobalStore.loginInfo().is_temp_coach == 0) {
                this.$GlobalStore.addModal('CommonAlertUi', {
                    title: '열람 권한이 없습니다',
                    contents: '해당 게시물은 시크릿 입단 요청서입니다.<br>전문가 인증을 완료한 감독님 및 코치님만 열람할 수 있습니다.',
                    okName: '확인',
                    isModalBackTransparent: true,
                    transitionName: '',
                })
            } else {
                if (this.$GlobalStore.loginInfo().is_coach == 0) {
                    this.$GlobalStore.addModal('CommonAlertUi', {
                        title: '전문가 인증이 필요합니다',
                        contents: '해당 게시물은 시크릿 입단 요청서입니다.<br>게시물 내용을 확인하시려면 전문가 인증을 완료해주세요.',
                        okName: '전문가 인증하기',
                        cancelName: '취소',
                        okAction: () => {
                            this.openChatCoachAndAdmin()
                        },
                        isModalBackTransparent: true,
                        transitionName: '',
                    })
                    return
                }
                
                if (is_send_request == 0 && is_confirm == 0) {
                    this.$GlobalStore.addModal('CommonAlertUi', {
                        title: '열람 권한이 필요합니다',
                        contents: '해당 게시물은 시크릿 입단 요청서입니다.<br>선수의 수락 후에만 상세 내용을 확인할 수 있습니다.<br><span style="color:#9E4CF6">열람 신청을 하시겠습니까?</span>',
                        cancelName: '취소',
                        okName: '열람 신청하기',
                        okAction: this.sendSecretRequest,
                        isModalBackTransparent: true,
                        transitionName: '',
                    })
                    return
                }

                if (is_skip == 1) {
                    this.$GlobalStore.showAlert('열람 요청이 거절된 요청서입니다')
                    return
                }

                if (is_send_request == 1 && is_confirm == 0) {
                    this.$GlobalStore.addModal('CommonAlertUi', {
                        title: '열람 요청 수락 대기중',
                        contents: '선수에게 성공적으로 열람 요청을 보냈습니다.<br>상대방이 수락하면 <span style="color:#9E4CF6">상세 입단 요청서</span>가 공개됩니다.',
                        okName: '다른 입단 요청서 둘러보기',
                        isModalBackTransparent: true,
                        transitionName: '',
                    })
                    return
                }
                this.$GlobalStore.addModal('RequestReportDetailSecret', { soccerhowIdx: this.userInfo.idx, completeAction: this.completeAction })
            }
        },
        async sendSecretRequest() {
            const formData = new FormData()
            formData.append('refer_idx', this.userInfo.idx)

            const res = await this.$Axios.post('/api/direct_message/send/secret_request', formData)

            if (res.data.code == ResponseCode.SUCCESS) {
                this.copyUserInfo.is_send_secret_request = 1
                this.$GlobalStore.addModal('CommonAlertUi', {
                    title: '열람 요청 수락 대기중',
                    contents: '선수에게 성공적으로 열람 요청을 보냈습니다.<br>상대방이 수락하면 <span style="color:#9E4CF6">상세 입단 요청서</span>가 공개됩니다.',
                    okName: '다른 입단 요청서 둘러보기',
                    isModalBackTransparent: true,
                    transitionName: '',
                })
            } else {
                this.$GlobalStore.showAlert(res.data.msg)
            }
        },
        async openChatCoachAndAdmin() {
            await this.$Axios.showPersonalChat(this.$Util.getAdminMemberIdx(), MEMBER_TYPE.USER, JOIN_CHAT_TYPE.CHAT_FOR_COACH_CERT);
        },
        formatInsertDate(dateStr) {
            if (!dateStr) return ''
            const insertDate = moment(dateStr, 'YYYY-MM-DD HH:mm:ss')
            if (!insertDate.isValid()) return dateStr

            const diffMinutes = moment().diff(insertDate, 'minutes')
            const diffHours = moment().diff(insertDate, 'hours')

            if (diffMinutes < 60) {
                return `${diffMinutes}분 전`
            } else if (diffHours < 24) {
                return `${diffHours}시간 전`
            } else {
                return insertDate.format('YYYY-MM-DD')
            }
        },
        setCopyUserInfo() {
            this.copyUserInfo = this.userInfo
        },
        async toggleLike() {
            const parameters = {}
            parameters.likeYn = this.curLikeYn === IS_LIKE.UNLIKE ? '0' : '1'
            parameters.idx = this.copyUserInfo.idx

            const res = await this.$Axios.post('/api/soccerhow/like', parameters)
            if (res.data.code === -1) {
                alert(res.data.msg)
            }
        },
        toggleTouch() {
            if (!this.$GlobalStore.isLogin()) {
                return
            }

            if (this.curLikeYn === IS_LIKE.UNLIKE) {
                this.$refs.soccerBall.style.transform = 'rotate(-180deg)'
                this.$refs.soccerBall.style.transition = 'all 0.3s'
            }

            if (!this.$Util.checkLoginAndWeb()) {
                return
            }

            if (this.curLikeYn === IS_LIKE.UNLIKE) {
                setTimeout(() => {
                    this.$refs.soccerBall.style.transition = 'all 0.3s'
                    this.$refs.soccerBall.style.transform = 'rotate(0)'
                    this.$refs.shoot.style.opacity = '1'
                    this.$refs.shoot.style.transition = 'all 0.3s'
                }, 100)
            } else {
                setTimeout(() => {
                    this.$refs.shoot.style.transition = ''
                    this.$refs.shoot.style.opacity = '0'
                }, 100)
            }
            const likeTemp = this.curLikeYn === IS_LIKE.UNLIKE ? '1' : '0'
            const likeNumber = this.curLikeYn === IS_LIKE.UNLIKE ? this.curLikeNumber + 1 : this.curLikeNumber - 1
            this.$set(this.copyUserInfo, 'like_yn', likeTemp)
            this.$set(this.copyUserInfo, 'like_number', likeNumber)
            this.$Util.sendEventClick('축구팀입단_게시물_좋아요', true)
            this.toggleLike()
            this.$Util.vibrate()
        }
    },
    created() {
        this.setCopyUserInfo()
    }
}
</script>

<style scoped>
.secret_request_btn {
    width: 97px;
    height: 28px;
    border-radius: 40px;
    color: #fff;
    text-align: center;
    background: linear-gradient(90deg, #862EE7 0%, #463DE1 100%);
    font-size: 12px;
    font-weight: 500;
    line-height: 28px;

}

.request_form_card {
    background-color: #fff;
    border-radius: 15px;
    box-shadow: 1px 1px 10px 0px #0000001A;
    background: linear-gradient(180deg, #F6E1FF 0%, #FFFFFF 100%);
    padding: 20px;
}

.not_elite_request_form_card {
    background: linear-gradient(360deg, #FFFFFF 0%, #F0F6FF 100%);
}

.elite_request_form_card {
    background: linear-gradient(180deg, #FFF7ED 0%, #FFFFFF 100%);
}

/* 상단 헤더 섹션 */
.header_section {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;
}

.profile_section {
    display: flex;
    gap: 12px;
    flex: 1;
    align-items: flex-start;
}

.profile-image {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
}

.profile_info {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.name_row {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.player_name {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    font-weight: 700;
    line-height: 24px;
    color: #000;
}

.tags {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
}

.tag {
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 700;
    color: #fff;
    white-space: nowrap;
}

.elite_tag {
    background-color: var(--color-main);
    border: 1px solid #FF711180;
}

.not_elite_tag {
    background-color: #c7c7c7;
}

.verified_tag {
    background: #82FFAD33;
    border: 1px solid #82FFAD;
    display: flex;
    color: #159941;
    align-items: center;
    gap: 4px;
}

.not_verified_tag {
    background: #C8C8C84D;
    border: 1px solid #c8c8c8;
    display: flex;
    align-items: center;
    gap: 4px;
    color: #989898;
}

.location {
    font-size: 12px;
    line-height: 16px;
    color: #808080;
}

.age_badge {
    background: linear-gradient(360deg, #210F03 0%, #6A6A6A 100%);
    color: #fff;
    padding: 4px 8px;
    border-radius: 8px;
    font-weight: 900;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: var(--color-main);
}

.not_elite_age_badge {
    background: #243444;
    color: #fff;
    padding: 4px 8px;
    border-radius: 8px;
    font-weight: 900;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #86BCFA;
}

/* 중앙 스탯 섹션 */
.stats_section {
    background: #9E4CF61A;
    border-radius: 12px;
    padding: 9px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-bottom: 10px;
}

.stat_item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    flex: 1;
}

.stat_label {
    font-size: 12px;
    color: #210F03;
    font-weight: 700;
}

.stat_value {
    font-weight: 700;
    color: #000;
    margin-top: 5px;
    font-size: 14px;
}

.stat_divider {
    width: 1px;
    height: 25px;
    background-color: #d9d9d9;
}

/* 희망 지역 섹션 */
.region_section {
    display: flex;
    gap: 10px;
    align-items: flex-start;
    margin-bottom: 10px;
    /* align-items: center; */
}
.region_label {
    font-size: 12px;
    font-weight: 700;
    color: #808080;
    flex-shrink: 0;
    margin-top: 5px;
}
.region_list {
    display: flex;
    gap: 5px;
    align-items: center;
    flex-wrap: wrap;
}
.region_item {
    background: #210F031A;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 500;
    padding: 6px 8px;
    flex-shrink: 0;
}
/* 하단 소개 섹션 */
.intro_section {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.quote {
    font-weight: 700;
    color: #000;
    line-height: 24px;
}

.intro_text_wrapper {
    position: relative;
    max-height: 96px;
    overflow: hidden;
    filter: blur(3px);
}

.intro_text {
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: #808080;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;

}

/*용병 마커 클래스*/
.ellipsis {
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical
}
</style>